import { Coverage } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { CoverageWithMeta } from '../Coverage.type';

const chooseCoverageTerm = (coverage: Coverage, chosenTermName: string): Coverage => ({
  ...coverage,
  terms: [{
    ...coverage.terms?.[0],
    chosenTermValue: chosenTermName,
  }],
});

export const chooseTermInCoverageWithMeta = (
  coverageWithMeta: CoverageWithMeta,
  chosenTermName: string,
): CoverageWithMeta => ({
  ...coverageWithMeta,
  coverage: chooseCoverageTerm(coverageWithMeta.coverage, chosenTermName),
});

export const replaceCoverageWithMeta = (
  coverageToReplace: CoverageWithMeta,
  coveragesWithMeta: CoverageWithMeta[],
): CoverageWithMeta[] => {
  const replacementCoverageIndex = coveragesWithMeta
    .findIndex((coverage) => coverage.codeIdentifier === coverageToReplace.codeIdentifier);
  const coveragesCopy = [...coveragesWithMeta];

  coveragesCopy.splice(replacementCoverageIndex, 1, coverageToReplace);

  return coveragesCopy;
};
